import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TextField } from 'shared/mui/Fields';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';

export const FormControlStyled = styled(FormControl)({
  margin: 0,
  padding: 0,
});

export const TextFieldStyled = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'hasValues',
})<{ hasValues: boolean }>(({ hasValues }) => ({
  margin: 0,
  '& .MuiOutlinedInput-root': {
    paddingRight: hasValues ? '36px' : undefined,
  },
}));

export const TooltipStyled = styled(TooltipWithInfoIcon)({
  position: 'absolute',
  right: '4px',
  top: '50%',
  transform: 'translateY(-50%)',
});
